module.exports = __webpack_public_path__ + "img/safe_move05.20123407.png";